import styles from './Section.module.scss';
const Section = ({ children, label }) => {
	return (
		<div className={styles.container}>
			<h3 className={styles.header}>{label}</h3>
			<div className={styles.body}>{children}</div>
		</div>
	);
};

export default Section;
